import styles from "./Graph.module.scss";
import { Drawer } from "antd";
import InformationBoard from "./InformationBoard";
import { IconPack } from "Explore/Config/Icons";
import { useState } from "react";

const InformationBoardMobile = (props) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        className={styles["information-board__container"]}
        onClick={() => setOpen(true)}
      >
        {IconPack.menuIcon}
      </div>

      <Drawer
        title="Graph Settings"
        placement={"bottom"}
        closable
        onClose={() => setOpen(false)}
        open={open}
        key={"bottom"}
        height={"auto"}
      >
        <InformationBoard {...props} />
      </Drawer>
    </>
  );
};

export default InformationBoardMobile;
